package com.bikompanion.data.gbfs

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
internal data class GbfsVehicleTypeDto(
    @SerialName("vehicle_type_id") val vehicleTypeId: String,
    @SerialName("form_factor") val formFactor: String = "",
    @SerialName("propulsion_type") val propulsionType: String = "",
)
